import { createClient } from "@supabase/supabase-js";

// URL + clé "publishable" : sans danger côté frontend.
// La sécurité réelle vient des règles RLS définies dans Supabase
// (lecture publique des avis approuvés, écriture réservée à l'admin connecté).
const supabaseUrl = "https://kgtyofutwbyqzqlfkxsm.supabase.co";
const supabaseKey = "sb_publishable_7fyRQZUSYCaRsR2h1pHmTQ_HJbNIoM1";

export const supabase = createClient(supabaseUrl, supabaseKey);

// Bucket de stockage des photos avant/après
export const PHOTOS_BUCKET = "photos";

// Construit le chemin de stockage à partir d'une URL publique (pour suppression)
export function storagePathFromPublicUrl(url) {
  const marker = `/object/public/${PHOTOS_BUCKET}/`;
  const i = url.indexOf(marker);
  return i === -1 ? null : url.slice(i + marker.length);
}
